const deliveryGoodsLsit = "/web/psyh/psmb/peisongmoban/list" //配送要货-配送模板列表查询
const deliveryGoodsDetails = "/web/psyh/psmb/peisongmoban/load" //配送要货-配送模板查看单条数据的详情
const deliveryGoodsSave = "/web/psyh/psmb/peisongmoban/save" //配送要货-配送模板保存
const deliveryGoodsDelete = "/web/psyh/psmb/peisongmoban/delete" //配送要货-配送模板删除
const distributionSupplyLsit = "/web/psgh/psmb/peisongmoban/list"//配送供货-配送模板列表查询
const distributionSupplyDetails = "/web/psgh/psmb/peisongmoban/load"//配送供货-配送模板查看单条数据的详情
const distributionSupplySave = "/web/psgh/psmb/peisongmoban/save"//配送供货-配送模板保存
const distributionSupplyDelete = "/web/psgh/psmb/peisongmoban/delete"//配送供货-配送模板删除
const templateGoods = "/web/main/peisongmobanselector/wupins/load"//配送供货、配送要货-新建配送申请单读取指定模板的物品列表
const templateSelectList = "/web/main/peisongmobanselector/load"//配送供货、配送要货-新建配送申请单配送模板选择窗口

export {
  deliveryGoodsLsit,
  deliveryGoodsDetails,
  deliveryGoodsSave,
  deliveryGoodsDelete,
  distributionSupplyLsit,
  distributionSupplyDetails,
  distributionSupplySave,
  distributionSupplyDelete,
  templateGoods,
  templateSelectList
}


// WEBPACK FOOTER //
// ./src/api/api.js